// Photo gallery

$(function () {
  $('.jsImagePopup').magnificPopup({
    delegate: 'a',
    type: 'image',
    gallery: {enabled: true}
  })

  const itemsCount = $('.jsGallery a').length;

  $('.jsGallery').owlCarousel({
    loop: false,
    autoWidth: true,
    margin: 20,
    nav: false,
    items: itemsCount
  });
})

